import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { IFrameMessages } from './message-type.enum';
import { Message } from './message.interface';

export function ofTypeOld<T extends keyof IFrameMessages>(type: T) {
	return (source: Observable<Message>) =>
		source.pipe<any, { type: T; payload: IFrameMessages[T] }>(
			filter<Message>(m => m.type === type),
			map(msg => <{ type; payload: IFrameMessages[T] }>msg)
		);
}

export function toPayload<T extends keyof IFrameMessages>() {
	return (source: Observable<{ type: T; payload: IFrameMessages[T] }>) =>
		source.pipe<IFrameMessages[T]>(map(msg => <IFrameMessages[T]>msg.payload));
}
